import { render, staticRenderFns } from "./ProductTabs.vue?vue&type=template&id=65db75d5&scoped=true&"
import script from "./ProductTabs.vue?vue&type=script&lang=js&"
export * from "./ProductTabs.vue?vue&type=script&lang=js&"
import style0 from "./ProductTabs.vue?vue&type=style&index=0&id=65db75d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65db75d5",
  null
  
)

export default component.exports